import React from 'react'
import classnames from 'classnames'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import Enquiry from '../../enquiry'
import styles from './styles'

const Contacter = withStyles(styles)(props => {
  const { selected, contents, type, inc, count, classes } = props
  const data = contents.filter(x => x.type === type)[count[type]].content
  inc(type)
  return (
    data && (
      <div className={classes.page}>
        <div className={classes.contents}>
          <div className={classes.boxer}>
            <div className={classnames(classes.layout, classes.margins)}>
              {data.primary.step && (
                <Typography variant="title">
                  {data.primary.step.text}
                </Typography>
              )}
              <Typography variant="headline">
                {data.primary.title.text}
              </Typography>
              <Typography variant="subheading">
                {data.primary.subtitle.text}
              </Typography>
            </div>
            <div className={classes.boxerContents}>
              <Grid container spacing={40}>
                <Grid item xs={12}>
                  <Typography>Selected Resources</Typography>
                </Grid>
                <Grid container direction="row" />
                {selected.map(item => {
                  return (
                    <Grid item className={classes.selectedResource}>
                      <Typography variant={'caption'} style={{ color: '#fff' }}>
                        {item}
                      </Typography>
                    </Grid>
                  )
                })}
              </Grid>
              <Enquiry data={selected} type={data.type} />
            </div>
          </div>
        </div>
      </div>
    )
  )
})

export default withStyles(styles)(Contacter)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/contacter.js